import { styled } from "twin.macro";

export const SupplierListStyled = styled.div`
	overflow: visible;
`;
